<ng-template #panel>
  <div
    #panelEl
    class="if-drawer"
    [class.if-drawer--md]="width() === 'md'"
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    [attr.aria-labelledby]="titleId"
    (keydown)="onKeydown($event)">
    <header class="if-drawer__header">
      <div class="if-drawer__titles">
        @if (eyebrow()) {
          <p class="if-drawer__eyebrow">{{ eyebrow() }}</p>
        }
        <h2 class="if-drawer__title" [id]="titleId" appTitleIfTruncated>{{ heading() }}</h2>
        <div class="if-drawer__meta"><ng-content select="[drawerMeta]" /></div>
      </div>
      <div class="if-drawer__actions">
        <ng-content select="[drawerActions]" />
        <button type="button" class="if-drawer__close" [attr.aria-label]="closeLabel()" (click)="close()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </header>
    <div class="if-drawer__body">
      <ng-content />
    </div>
    <footer class="if-drawer__footer"><ng-content select="[drawerFooter]" /></footer>
  </div>
</ng-template>
